export default {
	title: "Centro Personal",
	subTitle: ["Perfil", "Seguridad", "Sistema"],
	menu: [
		"Modificar Información Personal",
		"Nombre de usuario",
		"Actualizar Contraseña",
		"Actualizar Contraseña de Transacción"
	],
	updatePassword: {
		form: {
			label: ["Contraseña Anterior", "Nueva Contraseña", "Confirmar Nueva Contraseña"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Contraseña Anterior", "Nueva Contraseña", "Confirmar Nueva Contraseña"]
		}
	}
};
